export default __webpack_public_path__ + "9bedc966261d4c472957bd9b491b3935.jpg";